import React, { Component } from "react"
import configs from '../../../configs.json'

class TopBtn extends Component {
    constructor(props) {
        super(props)
        this.handleClick       = this.handleClick.bind(this)
        this.handleScroll      = this.handleScroll.bind(this)
        this.componentDidMount = this.componentDidMount.bind(this)
    }
    handleClick(event) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    }
    handleScroll() {
        const btn = document.getElementById('top-btn')
        const min = 110
        const max = 1050
        const d1  = document.body.scrollHeight            - document.body.scrollTop
        const d2  = document.documentElement.scrollHeight - document.documentElement.scrollTop

        console.log(d1)
        console.log(d2)
        if (document.body.scrollTop > min || document.documentElement.scrollTop > min) {
            btn.style.display = "block";
        } else {
            btn.style.display = "none";
        }
        if (d1 < max || d2 < max) {
            btn.style.bottom  = '80px'
        } else {
            btn.style.bottom  = '20px'
        }
    }
    componentDidMount() {
        const handler   = this.handleScroll
        window.onscroll = function() {handler()}
    }
    render() {
        return (
            <button id='top-btn' style={{display: 'none', position: 'fixed', bottom: '20px', right: '10px', zIndex: '99', backgroundColor: configs.colors.secondary, paddingLeft: '8px', paddingRight: '8px'}} className="btn-small hoverable" onClick={(event) => this.handleClick(event)}>
                <i className="material-icons large">
                    arrow_upward
                </i>
            </button>
        )
    }
}

export default TopBtn;